var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileForNoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 53.5,
    stroke: "url(#paint0_linear_1297_11772)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 53.6087,
    cy: 34.8262,
    r: 14.4783,
    fill: "url(#paint1_linear_1297_11772)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 53.6087,
    cy: 69.6522,
    rx: 27,
    ry: 17.2174,
    fill: "url(#paint2_linear_1297_11772)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1297_11772",
    x1: 108,
    y1: 0,
    x2: -2.75029,
    y2: 2.8981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1297_11772",
    x1: 68.087,
    y1: 20.3479,
    x2: 38.393,
    y2: 21.1249,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1297_11772",
    x1: 80.6087,
    y1: 52.4348,
    x2: 25.2888,
    y2: 54.7049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB79F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#5F49B5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileForNoImg);
export default __webpack_public_path__ + "static/media/profile-for-no-img.cce30fc589d78417d375942f2ab38a06.svg";
export { ForwardRef as ReactComponent };